const NATIVE_TAB_HOST_URL = process.env.REACT_APP_NATIVE_TAB_HOST_URL || '';

export function isInNativeTab(): boolean {
  try {
    return window.location !== window.parent.location;
  } catch {
    return true; // cross-origin = we're in an iframe
  }
}

export function requestReauthentication(returnPath: string = '/dashboard'): void {
  if (!isInNativeTab()) return;
  const message = { type: 'RequestReauthentication', url: returnPath };
  if (NATIVE_TAB_HOST_URL) {
    window.parent.postMessage(JSON.stringify(message), NATIVE_TAB_HOST_URL);
  }
}

export function notifyLocationChanged(url: string, featureName: string): void {
  if (!isInNativeTab()) return;
  const message = { type: 'LocationChanged', url, title: { featureName } };
  if (NATIVE_TAB_HOST_URL) {
    window.parent.postMessage(JSON.stringify(message), NATIVE_TAB_HOST_URL);
  }
}
